
<template>
  <div><span class="collection-total-results body-sm">{{currentTotal}} {{results}}</span></div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CollectionTotalResults',
  computed: {
    ...mapState({
      currentTotal: state => state.collections.currentTotal,
      currentFilters: state => state.collections.currentFilters
    }),
    results () {
      if (this.currentTotal === 1) {
        return 'Product'
      } else {
        return 'Products'
      }
    },
    filters () {
      if (this.currentFilters.length === 1) {
        return 'Filter'
      } else {
        return 'Filters'
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .collection-total-results {
    margin-right: 24px;
    vertical-align: middle;
    min-width: 64px;
    display: block;
    color: $color-black-700;
    line-height: 16px;
    @include mobile-tablet {
      display: block;
      width: 100%;
      text-align: center;
      margin: 0 0 8px 0;
    }
    &.italicized {
      font-style: italic;
    }
  }
</style>
